import es from './es.json'

const languages = { es }

export default languages
